// extracted by mini-css-extract-plugin
export default {"tooltip":"KU-z","arrow":"LU-z"};